/* eslint-disable no-prototype-builtins */
import { takeLatest, call, put } from 'redux-saga/effects';
import { callApi } from '../utils/api';
import URLS from '../constants/urls';
import * as userActions from '../actions/userActions';
import * as SnackbarAction from '../actions/snackbarAction';

export function* inviteUserAct(action) {
  try {
    const res = yield call(callApi, URLS.INVITE_USER, 'POST', action.payload);
    yield put(userActions.userInviteStatus(true));
    yield put(
      SnackbarAction.openSnackbar({ message: res.res_str, type: 'success' }),
    );
    if (window.hasOwnProperty('Intercom')) {
      const metadata = {
        emp_invite_sent: 'YES',
      };
      window.Intercom('trackEvent', 'emp-invite', metadata);
    }
  } catch (error) {
    yield put(userActions.userInviteStatus(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* usersList(action) {
  let url = '';
  if (action.userType === 'pending') {
    url = URLS.PENDING_EMP_INVITE;
  } else {
    url = URLS.SEARCH;
  }
  try {
    const response = yield call(callApi, url, 'GET', action.payload);
    const res = {};
    if (action.userType === 'pending') {
      res.data = response.res_data.employees || [];
      res.count = (response.res_data.employees || []).length;
    } else {
      res.data = response.res_data.result;
      res.count = response.res_data.count;
    }

    yield put(userActions.setUsersList(res));
  } catch (error) {
    const res = {
      data: [],
      count: 0,
    };
    yield put(userActions.setUsersList(res));
    // console.log(`API failed - Login`);
  }
}

function* fetchUserDetails(action) {
  // console.log(action.userId);
  const params = {
    user_id: action.userId,
  };
  try {
    const userResponse = yield call(
      callApi,
      URLS.CONTROLLED_USER_INFO,
      'GET',
      params,
    );
    // console.log('res', response);
    yield put(userActions.userDetailsReceived(userResponse.res_data));
  } catch (error) {
    // console.log(`API failed - Login`);
  }
}

function* assignCard(action) {
  try {
    const res = yield call(callApi, URLS.ASSIGN_CARD, 'post', action.payload);
    yield put(userActions.userInviteStatus(true));
    yield put(
      SnackbarAction.openSnackbar({ message: res.res_str, type: 'success' }),
    );
  } catch (error) {
    yield put(userActions.userInviteStatus(false));
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
    // console.log(`API failed - Login`);
  }
}

function* getAllMerchant(action) {
  try {
    const res = yield call(callApi, URLS.GET_MERCHANT, 'get', action.payload);
    yield put(userActions.setMerchantData(res.res_data));
  } catch (error) {
    // console.log(`API failed - Login`);
  }
}

function* resendInvite(action) {
  try {
    const res = yield call(callApi, URLS.RESEND_INVITE, 'post', action.payload);
    yield put(
      SnackbarAction.openSnackbar({ message: res.res_str, type: 'success' }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* updateUserLimit(action) {
  try {
    const res = yield call(
      callApi,
      URLS.UPDATE_USER_LIMIT,
      'POST',
      action.payload,
    );
    yield put(userActions.getControlUserDetails(action.userId));
    yield put(userActions.saveLimitUpdateData({ data: res.res_data }));
    yield put(
      SnackbarAction.openSnackbar({ message: res.res_str, type: 'success' }),
    );
    if (action.cb) {
      yield put(action.cb);
    }
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* getControllledUser(action) {
  try {
    const res = yield call(
      callApi,
      URLS.CONTROLLED_USER,
      'GET',
      action.payload,
    );
    yield put(userActions.setControlUsers(res.res_data.choices));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* updateUserAddOnboard(action) {
  try {
    const res = yield call(callApi, URLS.USER_ONBOARD_FLOW, 'POST', {
      data: JSON.stringify(action.data),
    });
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

export function* usersSaga() {
  yield takeLatest('INVITE_USER', inviteUserAct);
  yield takeLatest('GET_USER_LIST', usersList);
  yield takeLatest('GET_CONTROLLED_USER_DETAILS', fetchUserDetails);
  yield takeLatest('ASSIGN_CARD', assignCard);
  yield takeLatest('GET_MERCHANT', getAllMerchant);
  yield takeLatest('RESEND_INVITE', resendInvite);
  yield takeLatest('UPDATE_USER_LIMIT', updateUserLimit);
  yield takeLatest('CONTROLLED_USER', getControllledUser);
  yield takeLatest('ONBOARD_USER_ADD', updateUserAddOnboard);
  // yield takeLatest('CONTROLLED_USER_DETAILS_RECEIVED', setUserDetails);
}
